import { PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { CuraButton, CuraHeading, CuraParagraph } from '@rededor/cura-react'

import { sendEvent } from '@/services/mixPanelService'

import { Show } from '@/components/Show'
import { CallCenter } from '@/components/CallCenter'
import { ButtonWhatsApp } from '@/components/ButtonWhatsApp'
import { useStepbarStore } from '@/store/useStepbarStore'

import { UnitsNearby } from './UnitsNearby'
import { UnitNearbyPrivate } from './UnitNearbyPrivate'
import {
  ButtonsContinuesWrapper,
  Root as StyledRoot,
  WrapperButtons
} from './styles'
import { useFallbackStore } from '@/store/useFallbackStore'

interface ButtonsContinueProps {
  openChat: any
  withWhatsapp?: boolean
  whatsAppMessage?: string
}

const WithFallbackCleanUp = ({ children }: PropsWithChildren) => {
  const [mounted, setMounted] = useState(false)
  const setStepWithError = useStepbarStore((state) => state.setStepWithError)
  const resetFallbackStore = useFallbackStore((s) => s.reset)

  const cleanUp = useCallback(() => {
    if (!mounted) {
      return
    }
    resetFallbackStore()

    setStepWithError(null)
  }, [mounted, resetFallbackStore, setStepWithError])

  useEffect(() => {
    setMounted(true)

    return cleanUp
  }, [cleanUp])
  return <>{children}</>
}

export const Root = ({ children }) => {
  return (
    <StyledRoot>
      <WithFallbackCleanUp>{children}</WithFallbackCleanUp>
    </StyledRoot>
  )
}

export const Title = ({ children }) => (
  <CuraHeading level={2} color="neutral-dark" size="small" marginBlock="0">
    {children}
  </CuraHeading>
)

export const SubTitle = ({ children }) => (
  <CuraParagraph color="neutral-dark" marginBlock="24px 0">
    {children}
  </CuraParagraph>
)

export const ButtonsContinue = ({
  openChat,
  withWhatsapp = true,
  whatsAppMessage
}: ButtonsContinueProps) => {
  const handleClickChat = () => {
    sendEvent({
      eventName: 'CTA',
      data: {
        LABEL: 'Continue através do chat',
        DESCRIPTION: 'Transbordo para chat',
        ACTION: 'Transbordo para chat',
        TYPE: 'button'
      }
    })

    openChat()
  }

  return (
    <ButtonsContinuesWrapper $withWhatsapp={withWhatsapp}>
      <CuraButton
        style={{
          width: '100%'
        }}
        color="primary"
        fontColor="light"
        iconName="chatCircle"
        iconPosition="right"
        size="medium"
        onClick={handleClickChat}
      >
        CONTINUE POR CHAT
      </CuraButton>
      <Show when={withWhatsapp}>
        <ButtonWhatsApp message={whatsAppMessage} />
      </Show>
    </ButtonsContinuesWrapper>
  )
}

export const ButtonCallCenter = ({ isMobile }) => {
  return (
    <Show when={isMobile}>
      <CallCenter.Button />
      <CallCenter.Info />
    </Show>
  )
}

export const Fallback = {
  UnitNearbyPrivate,
  ButtonCallCenter,
  ButtonsContinue,
  WrapperButtons,
  UnitsNearby,
  SubTitle,
  Title,
  Root
}
